var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HMModalContainer',[_c('template',{slot:"header"},[_c('HMHeader')],1),_c('GetResetPassword',{on:{"go-to-login":function($event){return _vm.$router.push({ name: 'admin-login' })}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }